jQuery(document).ready(function($){
	console.log('Welcome to AIC Gold Theme!');
});